module.exports = __webpack_public_path__ + "static/img/login.d7e611a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/login.png
// module id = u5zf
// module chunks = 4